<span matSnackBarLabel>
  {{data.message}}
</span>
<span matSnackBarActions>
  @if(this.data.linkInfo) {
    <a mat-raised-button color="primary" class="medium link-button" href="{{this.data.linkInfo.hrefUrl}}">{{this.data.linkInfo.displayText}}</a>
  }
  <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()"><mat-icon>close</mat-icon></button>
</span>
